export default __webpack_public_path__ + "static/media/ultrasound.f7b7238d.jpg";